export default {
  getGPSSettings: {
    method: 'get',
    url: '/p/settings/gps'
  },
  updateGPSSettings: {
    method: 'post',
    url: '/p/settings/gps'
  }
}
